import { REHYDRATE } from 'redux-persist';
import {
  CAREER_FETCH_BEGIN,
  CAREER_FETCH_FAIL,
  CAREER_FETCH_SUCCESS,
  CAREER_PUT_BEGIN,
  CAREER_PUT_FAIL,
  CAREER_PUT_SUCCESS,
  CAREER_NEXT_STEP,
} from '../actions/careerActions';

import { ANY_FIELD_UPDATE, updatedObject } from '../actions/formActions';
import { LOGOUT } from '../actions/loginStateActions';

export default function careerWorkspaceReducer(
  state = { data: {}, activeStep: 0, status: 'uninitialized' },
  action
) {
  switch (action.type) {
    case REHYDRATE: {
      if (action.payload != null && action.payload.career != null) return action.payload.career;
      return state;
    }

    case ANY_FIELD_UPDATE: {
      if (action.storeName !== 'career') return state;

      return {
        ...state,
        data: updatedObject(state.data, action.accessPath, action.newVal),
      };
    }

    case CAREER_NEXT_STEP: {
      return { ...state, activeStep: state.activeStep + 1 };
    }

    case CAREER_FETCH_BEGIN: {
      const oldAnswers = state.data.answers || [];

      return {
        data: { answers: [...oldAnswers] },
        activeStep: state.activeStep,
        status: 'fetching',
      };
    }

    case CAREER_FETCH_SUCCESS: {
      const oldAnswers = state.data.answers || [];

      return {
        data: { ...action.data, answers: [...oldAnswers] },
        activeStep: state.activeStep,
        status: 'editing',
      };
    }

    case CAREER_FETCH_FAIL:
      return { data: {}, activeStep: 0, status: 'failed', failReason: action.reason };

    case CAREER_PUT_BEGIN:
      return { ...state, status: 'submitting' };

    case CAREER_PUT_SUCCESS:
      return { ...state, status: 'submitted' };

    case CAREER_PUT_FAIL:
      return { ...state, status: 'failed', failReason: action.reason };

    case LOGOUT:
      return { data: {}, activeStep: 0, status: 'uninitialized' };

    default:
      return state;
  }
}
